import { Routes } from '@angular/router';
import { InitialComponent } from './initial/initial.component';
import { InitialAuthGuard } from './initial/initial.guard';

export const appRoutes: Routes = [
  {
    path: '',
    component: InitialComponent,
    canActivate: [InitialAuthGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },

      {
        path: 'clinics',
        loadChildren: () =>
          import('./clinics/clinics-routing.module').then((m) => m.ContactRoutingModule),
      },
      {
        path: 'user',
        loadChildren: () =>
          import('./clinics/clinics-routing.module').then((m) => m.ContactRoutingModule),
      },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./dashboard/dashboard-routing.module').then((m) => m.DashboardRoutingModule),
      },
      {
        path: 'planner',
        loadChildren: () =>
          import('./planner/planner.routing.module').then((m) => m.ContactRoutingModule),
      },
      {
        path: 'provider',
        loadChildren: () =>
          import('./provider/provider.routing.module').then((m) => m.ProviderRoutingModule),
      },
      {
        path: 'skills',
        loadChildren: () =>
          import('./skills/skills.routing.module').then((m) => m.ContactRoutingModule),
      },
      {
        path: 'spots',
        loadChildren: () =>
          import('./spots/spots.routing.module').then((m) => m.ContactRoutingModule),
      },
      {
        path: 'billing-codes',
        loadChildren: () =>
          import('./billing-codes/billing.routing.module').then((m) => m.BillingRoutingModule),
      },
      {
        path: 'fee-schedules',
        loadChildren: () =>
          import('./fee-schedule/fee-schedule-routing.module').then(
            (m) => m.FeeScheduleRoutingModule
          ),
      },
      {
        path: 'payors',
        loadChildren: () =>
          import('./payers/payers-routing.module').then((m) => m.PayersRoutingModule),
      },
      {
        path: 'billing-rules',
        loadChildren: () =>
          import('./billing-rcm/pages/billing-rules/billing-rules-routing.module').then((m) => m.BillingRulesRoutingModule),
      },
      {
        path: 'billing-facilities',
        loadChildren: () =>
          import('./billing-rcm/pages/billing-facilities/billing-facilities-routing.module').then((m) => m.BillingFacilitiesRoutingModule),
      },
      {
        path: 'provider-networks',
        loadChildren: () =>
          import('./billing-rcm/pages/provider-networks/provider-networks-routing.module').then(
            (m) => m.ProviderNetworksRoutingModule,
          ),
      },
      {
        path: 'payments',
        loadChildren: () =>
          import('./payments/payments.routing.module').then((m) => m.PaymentsRoutingModule),
      },
      {
        path: 'encounters',
        loadChildren: () =>
          import('./encounters/encounters-routing.module').then((m) => m.EncountersRoutingModule),
      },
      {
        path: 'billing-rcm',
        loadChildren: () =>
          import('./billing-rcm/billing-rcm.module').then((m) => m.BillingRcmModule),
      },
      {
        path: 'records',
        loadChildren: () =>
          import('./billing-rcm/pages/work-queue/work-queue-routing.module').then((m) => m.ClaimRecordsRoutingModule),
      },
      {
        path: 'patient-ar',
        loadChildren: () =>
          import('./billing-rcm/pages/patient-ar/patient-ar-routing.module').then((m) => m.PatientArRoutingModule),
      },
      {
        path: 'contracts',
        loadChildren: () =>
          import('./contracts/contracts-routing.module').then((m) => m.ContactRoutingModule),
      },
      {
        path: 'solver',
        loadChildren: () =>
          import('./solver/solver.routing.module').then((m) => m.ContactRoutingModule),
      },
      {
        path: 'patient',
        loadChildren: () =>
          import('./patient/patient.routing.module').then((m) => m.ContactRoutingModule),
      },
      {
        path: 'patient-team',
        loadChildren: () =>
          import('./patient-team/patient-team.routing.module').then((m) => m.ContactRoutingModule),
      },
      {
        path: 'availability',
        loadChildren: () =>
          import('./availability/availability.routing.module').then((m) => m.ContactRoutingModule),
      },
      {
        path: 'scheduling',
        loadChildren: () =>
          import('./scheduling/scheduling.routing').then((m) => m.schedulingRoutes),
      },
      {
        path: 'therapygroup',
        loadChildren: () =>
          import('./behaviourtherapygroup/therapygroup.routing.module').then(
            (m) => m.ContactRoutingModule
          ),
      },
      {
        path: 'holidays',
        loadChildren: () =>
          import('./holidays/holidays-routing.module').then((m) => m.HolidaysRoutingModule),
      },
      {
        path: 'error',
        loadChildren: () => import('./error/error.module').then((m) => m.ErrorModule),
      },
      {
        path: 'setting',
        loadChildren: () =>
          import('./setting/setting-routing.module').then((m) => m.SettingRoutingModule),
      },
      {
        path: 'job-config',
        loadChildren: () =>
          import('./job-config/job-config-routing.module').then((m) => m.JobConfigRoutingModule),
      },
      {
        path: 'trash',
        loadChildren: () =>
          import('./job-config/trash-component/trash/trash-routing.module').then(
            (m) => m.TrashRoutingModule
          ),
      },
      {
        path: 'tasks',
        loadChildren: () => import('./tasks/tasks.module').then((m) => m.TasksModule),
      },
      // {
      //   path: 'chat',
      //   loadChildren: () => import('./chat/chat-routing.module').then((m) => m.ChatRoutingModule),
      // },
    ],
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./authenticate/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'forgot',
    loadComponent: () =>
      import('./authenticate/forgot-password/forgot-password.component').then(
        (m) => m.ForgotPasswordComponent
      ),
  },
  {
    path: 'forget-email-password/:user_id/:hash',
    loadComponent: () =>
      import('./authenticate/reset-password/reset-password.component').then(
        (m) => m.ResetPasswordComponent
      ),
  },
  {
    path: 'reset-password/:user_id',
    loadComponent: () =>
      import('./authenticate/reset-password/reset-password.component').then(
        (m) => m.ResetPasswordComponent
      ),
  },
  {
    path: '**',
    redirectTo: 'login',
  },
];

